import { takeLatest, call, put } from 'redux-saga/effects'

import { errorHandler } from '../../CandidateExperience/helpers/errorHelpers'

import { fetchStaticJobRoleEntitiesSaga } from '../../CandidateExperience/sagas/staticJobRoles'
import * as roleListView from '../reducks/roleList'

export function* fetchStaticJobRolesSaga() {
  try {
    const response = yield call(fetchStaticJobRoleEntitiesSaga)
    yield put(roleListView.fetchStaticJobRolesSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(roleListView.fetchStaticJobRolesError(error))
  }
}

export default function* watchRoleListSaga() {
  yield takeLatest(roleListView.FETCH_STATIC_JOB_ROLES, fetchStaticJobRolesSaga)
}
